import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { checkAuth } from '../services/auth';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAuth = async (retryCount = 0) => {
      try {
        // If we just came from OAuth redirect, wait a bit for cookie to be set
        // Check if we're on the admin page (likely just redirected from OAuth)
        const isOAuthRedirect = window.location.pathname === '/admin' && retryCount === 0;
        
        if (isOAuthRedirect) {
          // Wait 500ms for cookie to be available after redirect
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        const authData = await checkAuth();
        console.log('🔍 Auth check result:', authData);
        
        if (authData.authenticated) {
          setIsAuthenticated(true);
          setLoading(false);
        } else if (retryCount < 2 && isOAuthRedirect) {
          // Retry once more if we just came from OAuth (cookie might need more time)
          console.log('🔄 Retrying auth check (attempt', retryCount + 2, ')');
          setTimeout(() => verifyAuth(retryCount + 1), 1000);
        } else {
          setIsAuthenticated(false);
          setLoading(false);
        }
      } catch (error) {
        console.error('Auth verification error:', error);
        if (retryCount < 2) {
          // Retry on error
          setTimeout(() => verifyAuth(retryCount + 1), 1000);
        } else {
          setIsAuthenticated(false);
          setLoading(false);
        }
      }
    };

    verifyAuth();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;




